<template>
    <div class="channel-multiterm-choose">
        <div class="choose-left f-inlineblock-top">
            <h5 class="choose-tit f-clearfix">
                <p class="choose-tit-con f-fl">全部渠道</p>
                <a
                    class="choose-left-btn f-fr js-whole-open"
                    href="javascript:;"
                    @click="expandAllNode"
                >{{expandAll ? '收起全部' : '展开全部'}}</a>
            </h5>
            <div v-loading="loading">
                <el-tree
                    :default-expand-all="true"
                    class="el-tree-r"
                    :data="channels"
                    :show-checkbox="true"
                    node-key="id"
                    ref="channelTree"
                    @check="checkChange"
                    :props="treeProps"
                ></el-tree>
            </div>
        </div>
        <div class="choose-right f-inlineblock-top">
            <h5 class="choose-tit f-clearfix">
                <!--<p class="choose-tit-con f-fl">已选择渠道（<span class="dynamic-num">3</span>/<span class="fixed-num">200</span>）</p>-->
                <p class="choose-tit-con f-fl">已选择渠道</p>
            </h5>
            <ul class="choose-right-con g-scrollbar">
                <li class="choose-right-label" v-for="(channel,index) in checked" :key="index">
                    <span class="ico ico-tree-close f-inlineblock-top" @click="delChannel(channel)"></span>
                    <p class="crl-con f-inlineblock-top">
                        <span
                            class="crl-con-text f-inlineblock-top"
                            style="max-width: 400px"
                        >{{ channel.labels.join('>>') }}</span>
                    </p>
                </li>
            </ul>
        </div>
    </div>
</template>

<style  lang="scss" scoped>
@import "~Assets/sass/pages/v4/order/contribution.scss";
@import "~Assets/sass/pages/v4/order/order.scss";
@import "~Assets/sass/pages/v4/order/order_contribute.scss";
.el-tree-r {
    width: 90%;
    height: 390px;
    overflow-y: scroll;
    margin-top: 1rem;
}
.el-tree-r::-webkit-scrollbar {
    width: 4px;
    height: 4px;
}
.el-tree-r::-webkit-scrollbar-button {
    width: 0;
    height: 0;
}
.el-tree-r::-webkit-scrollbar-corner {
    display: block;
}
.el-tree-r::-webkit-scrollbar-thumb {
    background-clip: padding-box;
    background-color: #fd7e28;
    border-radius: 4px;
}
</style>

<script>
import {
    GameChannels 
} from "Services/getData.js";
export default {
    name: "tgl_channel.vue", // 官方媒体
    mounted() {
        this.getChannels();
        if (this.isAllowSelectParent === true) {
            this.treeProps.disabled = false;
        }
    },
    props: [
        "gameId",
        "isAllowSelectParent",
        "channelIds",
        "labels",
        "single",
        "hasQQChannel"
    ],
    data() {
        return {
            treeProps: {
                label: "channelName",
                id: "id",
                children: "children",
                disabled: "children"
            },
            channels: [],
            channelLabels: [],
            checked: [],
            expandAll: true,
            loading: false
        };
    },
    computed: {
        copyChannelIds: {
            get(){
                return this.channelIds
            },
            set(val){
                this.$emit("update:channelIds", val);
                // debugger
                this.$refs.channelTree.setCheckedKeys(val);
                // debugger
                if (val.length == 0) {
                    this.checked = [];
                }
            }
        }
    },
    watch: {
        gameId() {
            this.getChannels();
            // this.channelIds = [];
            this.channelLabels = [];
            this.checked = [];
        },
        channelLabels() {
            this.$emit("update:labels", this.channelLabels);
        },
        channelIds: {
            handler(curVal, oldVal) {
                this.$emit("update:channelIds", curVal);
                this.$refs.channelTree.setCheckedKeys(curVal);
                if (curVal.length == 0) {
                    this.checked = [];
                }
            },
            deep: true
        },
        checked: {
            handler(curVal, oldVal) {
                let hasQQChannel = false;
                for (let obj of curVal) {
                    if (obj.mainChannel == "qq") {
                        hasQQChannel = true;
                    }
                }
                this.$emit("update:hasQQChannel", hasQQChannel);
            },
            deep: true
        }
    },
    methods: {
        removeNode(node) {
            this.$refs.channelTree.setChecked(node, false);
        },
        async expandAllNode() {
            this.expandAll = !this.expandAll;
            for (
                let i = 0;
                i < this.$refs.channelTree.store._getAllNodes().length;
                i++
            ) {
                this.$refs.channelTree.store._getAllNodes()[
                    i
                ].expanded = this.expandAll;
            }
        },
        async getChannels() {
            if (!this.gameId) {
                return;
            }
            let ret = await GameChannels({
                gameId: this.gameId,
                isTree: 1
            });
            this.getTreeToNodes(ret.data.data);
            this.channels = ret.data.data;

            let that = this;
            this.$nextTick(() => {
                if (that.channelIds != null) {
                    let nodes = that.$refs.channelTree.getCheckedNodes();
                    nodes.map(item => {
                        if (item.labels.length > 0) {
                            this.channelLabels.push(item.labels);
                            this.checked.push(item);
                        }
                    });
                }
            });
        },
        delChannel(node) {
            let index = this.copyChannelIds.indexOf(node.id);
            if (index != -1) {
                this.copyChannelIds.splice(index, 1);
            }
            index = this.checked.indexOf(node);
            if (index != -1) {
                this.checked.splice(index, 1);
            }
        },
        checkChange(node, isChecked) {
            // let labels = null;
            // if (isChecked) {
            //     if (this.single === true) {
            //         // 如果只能单选
            //         this.channelIds = [];
            //         this.channelLabels = [];
            //         this.checked = [];
            //     }
            //     this.channelIds.push(node.id);
            //     this.channelLabels.push(node.labels);
            //     this.checked.push(node);
            // } else {
            //     let index = this.channelIds.indexOf(node.id);
            //     if (index != -1) {
            //         this.channelIds.splice(index, 1);
            //     }
            //     index = this.channelLabels.indexOf(node.labels);
            //     if (index != -1) {
            //         this.channelLabels.splice(index, 1);
            //     }
            //     index = this.checked.indexOf(node);
            //     if (index != -1) {
            //         this.checked.splice(index, 1);
            //     }
            // }
            // this.channelIds = [];
            this.channelLabels = [];
            this.checked = [];

            this.copyChannelIds = isChecked.checkedKeys || [];
            isChecked.checkedNodes.forEach(v => {
                this.channelLabels.push(v.labels);
            })
            this.checked = isChecked.checkedNodes
        },
        getchildrenNodes(cur, parent) {
            if (cur.labels == undefined) {
                cur.labels = [];
            }
            if (parent != null) {
                if (parent.labels != undefined) {
                    cur.labels = parent.labels.concat(cur.labels);
                }
            }
            cur.labels.push(cur.channelName);
            if (cur.children == undefined) {
                return;
            }
            for (let i = 0; i < cur.children.length; i++) {
                this.getchildrenNodes(cur.children[i], cur);
            }
        },
        getTreeToNodes(tree) {
            for (let i = 0; i < tree.length; i++) {
                this.getchildrenNodes(tree[i], null);
            }
        }
    }
};
</script>

